<footer class="sticky-footer">
  <div class="container my-auto">
    <div class="content text-right my-auto">
      <span>E-Policy Version: {{ appVersion }}</span>
    </div>
  </div>
</footer>
